const styles = {
  headerInfoWrap: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: '0 40px',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  companyName: {
    fontSize: 11,
    textTransform: 'uppercase',
    fontWeight: 500,
    marginTop: '12px',
    letterSpacing: '0.2px',
  },
  companyMessage: {
    margin: '12px 0 0',
    maxWidth: '327px',
    fontSize: 12,
    textAlign: 'center',
    display: '-webkit-box',
    maxHeight: '30px',
    lineHeight: '15px',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  waitMessage: {
    fontSize: 13,
    marginTop: '4px',
  },
  avatar: {
    position: 'relative',
    width: 300,
  },
};

export default styles;
